export default "__VITE_ASSET__Dx9QOfag__"